import {
    SEND_SUPPORT_REQUEST_START,
    SEND_SUPPORT_REQUEST_SUCCESS,
    SEND_SUPPORT_REQUEST_FAILURE,
    RESET_SUPPORT_REQUEST
} from '../actions/SupportRequestActions';

const defaultSupportRequest = {
    sending: false,
    sent: false,
    error: null
};

export default function supportRequest(state = defaultSupportRequest, action) {
    const { type, payload } = action;
    switch (type) {
        case SEND_SUPPORT_REQUEST_START:
            return {
                sending: true,
                sent: false,
                error: null
            };
        case SEND_SUPPORT_REQUEST_SUCCESS:
            return {
                sending: false,
                sent: true,
                error: null
            };
        case SEND_SUPPORT_REQUEST_FAILURE:
            return {
                sending: false,
                sent: true,
                error: payload
            };
        case RESET_SUPPORT_REQUEST:
            return defaultSupportRequest;
        default:
            return state;
    }
}
